import {PartialTenantCustomizations} from "src/tenantCustomizations/TenantCustomizations.ts";
import {defaultSpcSamplingMethods} from "src/tenantCustomizations/defaultTenantCustomizations.ts";

export const plgCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		spc: {
			enabled: true,
			processImprovementsEnabled: true,
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
	},
	spcSamplingMethods: () => [...defaultSpcSamplingMethods],
} as const;
